<template>
  <div>
    <b-table
      :items="items"
      :fields="methods"
      small
      :headVariant="productInfoPage ? 'light' : null"
      :borderless="!productInfoPage"
      :table-class="productInfoPage ? 'discount-pricing-table detail-page' : 'discount-pricing-table card-hover'"
    >
      <template v-for="field in methods" v-slot:[`head(${field.label})`]="data">
        <span
          v-b-popover.hover.top="'The prices shown under Check/Wire include a 4% cash discount. The prices shown under Bitcoin include a 3% cash discount. The prices shown under Credit Card are the full list price.'"
          v-html="data.field.label" />
      </template>

      <template v-for="field in methods" v-slot:[`cell(${field.key})`]="{ item }">
        <div v-if="field.type == 'Range'">
          <span>{{ range(item) }}</span>
        </div>
        <div v-else>
          <div class="d-flex flex-nowrap gap-5">
            <span class="price-color">${{ currencyFormat(item.price * (1 - field.discount_percentage)) }}</span>
          </div>
        </div>
      </template>

    </b-table>
  </div>

</template>

<script>
import { currencyFormat } from "../functions"

export default {
  props: ["items", "price", "methods", "productInfoPage"],
  data() {
    return {
      loadData: false,
      fields: [
        { key: "qty", label: "Quantity", type: "Range" }
      ],
      currencyFormat
    }
  },
  mounted() {
    // this.methods.forEach((paymentMethod) => {
    //   this.fields.push(
    //     {key: paymentMethod.vendors, label: paymentMethod.vendors, discount_percentage: paymentMethod.discount_percentage}
    //   )
    // })
    // this.loadData = true
  },
  methods: {
    range(item) {
      if (this.items.length == 1) {
        return "Any Quantity"
      }
      if (item.min_val && item.max_val) {
        return `${parseInt(item.min_val)} - ${parseInt(item.max_val)}`
      }
      if (!item.max_val) {
        return `+${parseInt(item.min_val)}`
      }
    }
  }
}
</script>

<style>
.price-color {
  color: #212529;
}

.gap-5 {
  gap: 5px;
}

.discount-pricing-table {
  table-layout: fixed;
}

.discount-pricing-table.detail-page {
  width: 55%;
}

@media (min-width: 1950px) {
  .discount-pricing-table.detail-page {
    width: 42%;
  }
}

.discount-pricing-table.card-hover {
  width: 100%;
}

.discount-pricing-table th,
.discount-pricing-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: clamp(10px, 0.9vw, 14px);
  text-align: center;
  vertical-align: middle;
}

.discount-pricing-table th:first-child,
.discount-pricing-table td:first-child {
  text-align: left;
}

.discount-pricing-table th span {
  white-space: normal;
  overflow: visible;
  text-overflow: initial;
  display: inline-block;
}

.discount-pricing-table td span,
.discount-pricing-table .price-color {
  font-size: inherit;
  display: inline-block;
  width: 100%;
}

.discount-pricing-table .d-flex {
  justify-content: center;
}

.table-sm td, .table-sm th {
  padding: 0.3rem 0.5rem !important;
}
</style>
